module.exports = __webpack_public_path__ + "static/media/ai.0e3df55d.svg";